import api from "./api";

export function getCourseFinderPage(country_id) {
  return api.get(`/coursefinderpage/${country_id}`);
}

export function createCourseFinderPage(data) {
  return api.post("/coursefinderpage", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateCourseFinderPage(country_id, data) {
  return api.put(`/coursefinderpage/${country_id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
